import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  Box,
} from '@chakra-ui/react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useSchedulerStore } from '../stores/SchedulerStore';
import { Logo } from './Logo';

interface MissingPostalCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MissingPostalCodeModal = ({
  isOpen,
  onClose,
}: MissingPostalCodeModalProps) => {
  const {
    setSelectedAddress,
    setAvailableAppointmentSlots,
    setIsMissingPostalCode,
  } = useSchedulerStore();

  const handleUpdateAddress = () => {
    // Reset to address selection view
    setSelectedAddress(null);
    setAvailableAppointmentSlots({});
    setIsMissingPostalCode(false);
    onClose();
  };

  const handleCallOffice = () => {
    // Trigger phone call
    window.location.href = 'tel:+16027801463';
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: 'full', lg: 'md' }}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
    >
      <ModalOverlay />
      <ModalContent>
        {/* Logo - only show on mobile/full screen */}
        <Box
          display={{ base: 'block', lg: 'none' }}
          w="40vw"
          h="30vw"
          m="0 auto"
          maxW="200px"
          maxH="150px"
          mt={4}
          mb={2}
        >
          <Logo />
        </Box>

        <ModalHeader pt={{ base: 2, lg: 6 }}>
          <Flex alignItems="center" gap={3}>
            <Box color="orange.500">
              <FaExclamationTriangle size={24} />
            </Box>
            <Text fontSize="lg" fontWeight="bold">
              Let's Double-Check Your ZIP Code
            </Text>
          </Flex>
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4} alignItems="flex-start">
            <Text>
              The ZIP code you entered isn't matching our current service map,
              but that could just mean we need to take a closer look.
            </Text>
            <Text>
              Please give our office a call — we'll confirm your location and
              help you get scheduled right away.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="messenger" onClick={handleUpdateAddress} mr={3}>
            Update Address
          </Button>
          <Button colorScheme="green" onClick={handleCallOffice}>
            Call Us
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
